import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  type AnyDynamicModalData,
  type DynamicModalStack,
  type ModalKeyNameType,
} from '@/common/types/modal';

interface AppInitialState {
  settingsIsOpen: boolean;
  presentationIsOpen: boolean;
  stockOverflowNotificationIsOpen: boolean;
  openChestIsActive: boolean;
  continueVipIsOpen: boolean;
  list: DynamicModalStack;
}

const initialState: AppInitialState = {
  settingsIsOpen: false,
  presentationIsOpen: false,
  stockOverflowNotificationIsOpen: false,
  openChestIsActive: false,
  continueVipIsOpen: false,
  list: [],
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    toggleSettingMenu: (state) => {
      state.settingsIsOpen = !state.settingsIsOpen;
    },
    toggleOpenPresentation: (state) => {
      state.presentationIsOpen = !state.presentationIsOpen;
    },
    setStockOverflowNotificationIsOpen: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.stockOverflowNotificationIsOpen = payload;
    },
    setOpenChestIsActive: (state, { payload }: PayloadAction<boolean>) => {
      state.openChestIsActive = payload;
    },
    setContinueVipIsOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.continueVipIsOpen = payload;
    },
    addFullscreenModal: (
      state,
      { payload }: PayloadAction<AnyDynamicModalData>,
    ) => {
      state.list.push(payload);
    },
    removeFullscreenModal: (
      state,
      { payload }: PayloadAction<ModalKeyNameType>,
    ) => {
      state.list = state.list.filter(({ name }) => name !== payload);
    },
  },
});

export const {
  toggleSettingMenu,
  toggleOpenPresentation,
  setStockOverflowNotificationIsOpen,
  setOpenChestIsActive,
  setContinueVipIsOpen,
  addFullscreenModal,
  removeFullscreenModal,
} = modalsSlice.actions;
export default modalsSlice.reducer;
